module.exports = __webpack_public_path__ + "assets/logoakademia.ru.25da24e0ab1f46c5d804425e82eeb403cb1dc9feba1efaee63172ca9cc3f4556.jpg";